import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import App from './App.vue'
import router from './router'
import store from './store'
import API from './api'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { getGroup } from './api/getGroup'

const moment = require('moment');

library.add(fas);
library.add(far);
library.add(fab);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(require('vue-moment'));
Vue.use(BootstrapVue);
Vue.use(API);

Vue.config.productionTip = false;

// Login with token parameter
import { useTokenParam } from './api/client';
useTokenParam();

new Vue({
    router,
    store,
    render: h => h(App),
    filters: {
        datetime: (t) => moment(t).local().format("LLLL")
    },
    async created() {
        // Set the theme
        document.body.className = store.state.theme;

        const { site } = await getGroup();
        if (site && !site.enabled) {
            this.$router.push({ name: "group_disabled" });
        }
    },
}).$mount("#app")
